import { v4 as uuid } from 'uuid';
import { store } from '../stores/store';
import { FileUploadInterface } from './Profile';

export interface HistoryViewItemLevel {
  id: string;
  taskId: string;
  taskName: string;
  subTaskId: string;
  subTaskName: string;
  dateTime: string;
  status: string;
  descriptionOfWork: string;
  appUserId: string;
  username: string;
  itemId: string;
  comments: string;
  flag: boolean;
  departmentName: null;
  files: FileUploadInterface[] | [];
  photos: FileUploadInterface[] | [];
  url?: string;
  duration?: any;
  trackerFromTime?: string;
  type?: string;
  direction?: string;
}
export const historyIntialState = {
  id: uuid(),
  dateTime: new Date().toISOString(),
  taskId: '',
  taskName: '',
  subTaskId: '',
  subTaskName: '',
  descriptionOfWork: '',
  appUserId: '',
  status: '',
  username: '',
  url: '',
  duration: '',
};

export const historyInitialState: HistoryViewItemLevel = {
  id: uuid(),
  taskId: '',
  taskName: '',
  subTaskId: '',
  subTaskName: '',
  dateTime: '',
  status: '',
  descriptionOfWork: '',
  appUserId: '',
  username: '',
  itemId: '',
  comments: '',
  flag: false, // Assuming default value for boolean flag is false
  departmentName: null,
  files: [],
  photos: [],
  url: '',
  trackerFromTime: '',
  type: '',
  direction: '',
};

export type historyPayloadType = {
  taskId: string;
  taskName: string;
  subTaskId: string;
  subTaskName: string;
  status: string;
  date: Date;
};

// export async function updateHistoryMain(
//   taskId: string,
//   taskName: string,
//   subTaskId: string,
//   subTaskName: string,
//   // descriptionOfWork: string,
//   itemId: string,
//   // comments: string,
//   // flag: boolean,
//   // departmentName: string,
//   // files: FileUploadInterface[] | [],
//   // photos: FileUploadInterface[] | [],
//   // activity: Activity | undefined | any,
//   status: string,
//   // title: string | undefined,
//   // url?: string,
//   // duration?: string,
//   noToast?: boolean,
//   // defaultStatus?: string,
// ) {
//   // if (activity) {
//   const userName =
//     store.userStore.user?.displayName !== undefined
//       ? store.userStore.user?.displayName
//       : '';
//   const title = store.activityStore.selectedActivity?.title;
//   // const userId =
//   //   store.userStore.user?.id !== undefined ? store.userStore.user?.id : '';

//   const itemHisData: historyPayloadType = {
//     taskId: taskId,
//     taskName: taskName,
//     subTaskId: subTaskId,
//     subTaskName: subTaskName,
//     status: `${userName} ${status} ${title}`,
//   };
//   // const HistoryArr = {
//   //   ...activity,
//   //   current_user: userName,
//   //   itemHistory: [itemHisData],
//   // };
//   // await store?.activityStore?.createHistoryAssetSave(
//   //   HistoryArr,
//   //   itemHisData,
//   //   noToast,
//   //   // completeHandler,
//   //   // id
//   // );
//   await store.viewStore.addHistory({ itemId }, itemHisData, noToast);
//   // }
// }

export async function updateHistoryMain(
  payload: historyPayloadType,
  noToast?: boolean,
  fullStatus?: boolean,
  noRefresh?: boolean,
  id?:string,
  titleName?:string
) {
  const itemId: string = store.activityStore.selectedActivity?.id;
  const userName =
    store.userStore.user?.displayName !== undefined
      ? store.userStore.user?.displayName
      : '';
  const title = store.activityStore.selectedActivity?.title || titleName;
  payload.status = fullStatus
    ? payload.status
    : `${userName} ${payload.status} ${title}`;
  await store.viewStore.addHistory(
    itemId === undefined ? { itemId: id || '' } : { itemId },
    payload,
    noToast || false,
    noRefresh || false,
  );
}

// export function historyReturnArr(
//   taskId: string,
//   taskName: string,
//   subTaskId: string,
//   subTaskName: string,
//   descriptionOfWork: string,
//   itemId: string,
//   comments: string,
//   flag: boolean,
//   departmentName: string,
//   files: FileUploadInterface[] | [],
//   photos: FileUploadInterface[] | [],
//   activity: Activity,
//   status: string,
//   title: string,
//   url: string,
//   duration?: string,
// ): any {
//   if (activity) {
//     const userName =
//       store.userStore.user?.displayName !== undefined
//         ? store.userStore.user?.displayName
//         : '';
//     const userId =
//       store.userStore.user?.id !== undefined ? store.userStore.user?.id : '';

//     return {
//       id: uuid(),
//       taskId: taskId,
//       taskName: taskName,
//       subtaskId: subTaskId,
//       subTaskName: subTaskName,
//       dateTime: new Date().toISOString(),
//       descriptionOfWork: descriptionOfWork,
//       username: userName,
//       appUserId: userId,
//       itemId: itemId,
//       comments: comments,
//       flag: flag,
//       departmentName: departmentName,
//       files: files,
//       photos: photos,
//       status: `${userName} ${status} ${title}`,
//       url: url,
//       duration: duration,
//     };
//   }
// }

export function SimpleHistoryReturn(
  title: string,
  status: string,
  itemId: string,
) {
  return {
    id: uuid(),
    itemId,
    appUserId:
      store.userStore.user?.id !== undefined ? store.userStore.user.id : '',
    username:
      store.userStore.user?.displayName !== undefined
        ? store.userStore.user.displayName
        : '',
    dateTime: new Date().toISOString(),
    url:
      store.userStore.user?.image !== undefined
        ? store.userStore.user.image
        : '',
    status: `User ${store.userStore.user
      ?.displayName!} created "${title}" ${status}`,
  };
}
